'use client';

import ContactInquiryPanel from '@/app/[locale]/contact/components/ContactInquiryPanel';
import ProductsFaq from '@/components/sections/Products/ProductsFaq';
import type { LeadForm } from '@/types/lead-forms';

interface FAQ {
  id: number;
  faqTitle: string;
  faqContent: string;
}

interface FaqEnquiryGridProps {
  faqs: FAQ[];
  leadForms?: LeadForm[];
}

export default function FaqEnquiryGrid({ faqs, leadForms }: FaqEnquiryGridProps) {
  return (
    <div className="grid grid-cols-1 items-start gap-8 sm:gap-10 lg:grid-cols-[1fr_1.15fr] lg:gap-12">
      <ProductsFaq faqs={faqs} />
      <div className="min-w-0">
        <ContactInquiryPanel leadForms={leadForms} />
      </div>
    </div>
  );
}
